import { type OrgUnit, type TeamSummary } from '@gb-ticket/shared-types';

/** Active options for assignment selects; keep an inactive current value visible. */
export function mergeOrgOptions<T extends { id: string; isActive: boolean }>(
  options: T[],
  current: T | null | undefined,
): T[] {
  const active = options.filter((item) => item.isActive);
  if (!current) {
    return active;
  }
  if (active.some((item) => item.id === current.id)) {
    return active;
  }
  return [current, ...active];
}

export function departmentSelectOptions(
  lookups: OrgUnit[] | undefined,
  current: OrgUnit | null | undefined,
): OrgUnit[] {
  return mergeOrgOptions(lookups ?? [], current);
}

export function teamSelectOptions(
  lookups: TeamSummary[] | undefined,
  current: TeamSummary | null | undefined,
): TeamSummary[] {
  return mergeOrgOptions(lookups ?? [], current);
}
